import { combineReducers } from 'redux';
import devBudgetReducer from './devBudgetReducer';

const rootReducer = combineReducers({ devBudget: devBudgetReducer });

export default rootReducer;
